import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';

const ChoosingWoodSpecies = () => {
  return (
    <div className={styles['article-page']}>
      <div className={styles.page}>
        <header className={styles['article-header']}>
          <SiteTopNav variant="light" />
        </header>

        <main className={styles['article-main']}>
          <Link className={styles['article-back']} to="/academy/hardwood-basics">
            ← Back to Flooring 101
          </Link>

          <p className={styles['article-eyebrow']} data-motion="copy">
            Sakura Floors Academy
          </p>

          <h1 className={styles['article-title']} data-motion="hero">
            Choosing Wood Species
          </h1>

          <p className={styles['article-intro']} data-motion="copy">
            Species is the foundation of a floor&rsquo;s color, grain, and durability — it&rsquo;s
            often the very first decision in the design process.
          </p>

          <p className={styles['article-intro']} data-motion="copy">
            From the warm familiarity of White Oak to the rich depth of Walnut, each species brings
            its own personality to a room.
          </p>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Overview</p>

            <h2 className={styles['article-section__title']}>What Species Affects</h2>

            <p className={styles['article-section__text']}>
              Before comparing individual species, it helps to understand exactly what changes from
              one species to the next.
            </p>

            <ul className={styles['article-list']}>
              <li>Grain pattern</li>
              <li>Color and tonal range</li>
              <li>Hardness and durability</li>
              <li>Overall character</li>
              <li>How the floor reads in different light</li>
            </ul>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Species Guide</p>

            <h2 className={styles['article-section__title']}>Popular Species at a Glance</h2>

            <div className={styles['article-feature-list']}>
              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>White Oak</h3>
                <p className={styles['article-feature__text']}>
                  Warm, versatile, and prized for its strength and classic grain.
                </p>
              </div>

              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>European Oak</h3>
                <p className={styles['article-feature__text']}>
                  A tighter grain and a slightly deeper tone than domestic white oak.
                </p>
              </div>

              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Japanese Oak</h3>
                <p className={styles['article-feature__text']}>
                  A refined, subtly lighter grain with understated character.
                </p>
              </div>

              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Ash</h3>
                <p className={styles['article-feature__text']}>
                  Light, contemporary tones with pronounced, linear grain.
                </p>
              </div>

              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Walnut</h3>
                <p className={styles['article-feature__text']}>
                  Rich, dark, and naturally luxurious, with a smoother grain pattern.
                </p>
              </div>
            </div>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Considerations</p>

            <h2 className={styles['article-section__title']}>Matching Species to Your Space</h2>

            <p className={styles['article-section__text']}>
              The best species for your home depends on more than personal preference — it should
              also complement the room itself.
            </p>

            <ul className={styles['article-list']}>
              <li>Natural light — brighter rooms can carry deeper tones</li>
              <li>Interior style — modern, transitional, or traditional</li>
              <li>Existing furniture and cabinetry tones</li>
              <li>Hardness needs for high-traffic areas</li>
            </ul>
          </section>
        </main>
      </div>
    </div>
  );
};

export default ChoosingWoodSpecies;
